import React from 'react';
import {Table as BaseTable} from 'desktop/sports/mlb/players-list/tiers';

class Table extends BaseTable {}

export {Table};
